import { render, staticRenderFns } from "./WaterGraph1D.vue?vue&type=template&id=81865a10&scoped=true&"
import script from "./WaterGraph1D.vue?vue&type=script&lang=js&"
export * from "./WaterGraph1D.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81865a10",
  null
  
)

export default component.exports